import { router } from '../../utils';
import { getUserInformation } from './getUserInformation';
import { listRecentWinners } from './listRecentWinners';
import { openLootbox } from './openLootbox';
export const rewardHubContract = router({
    openLootbox,
    listRecentWinners,
    getUserInformation,
}, {
    pathPrefix: '/reward-hub',
});
